/**
 * Main Theme JavaScript
 * 
 * This is the main entry point for your theme's frontend JavaScript
 */

import Image from './Image.js';
import { createRoot } from 'react-dom/client';
import Searchpage from './Searchpage.js';
import Homepage from './Homepage.js';
import Mappage from './Mappage.js';
import Favorites from './Favorites.js';
import ChartComponent from './ChartComponent.js';





// Example: Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {

  // Your vanilla JS code here
  initMobileMenu();
  initScrollEffects();
  
  // Initialize Chart Component
  initChartComponent();
});

function initMobileMenu() {
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
    });
  }
}

function initScrollEffects() {
  // Add scroll-based animations or effects
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    // Your scroll logic here
  });
}

const safeWaterDATA = window.safeWaterDATA || {}
const facility = window.safeWaterDATA.facilities || []

const homeEl = document.getElementById('root');
if (homeEl) {
  const homeRoot = createRoot(homeEl);
  homeRoot.render(
    <Homepage facility={facility} />
  );
}

/* Search Page */
const safeWaterSearchData = window.safeWaterDATA || {}
const searchRegions = window.safeWaterDATA.facilities || []

console.log(searchRegions,"searchRegions")
const searchEl = document.getElementById('search-root');
if (searchEl) {
  const searchRoot = createRoot(searchEl);
  searchRoot.render(
    <Searchpage regionsData={searchRegions} />
  );
}


const mapEl = document.getElementById('map-root');
if (mapEl) {
  const mapRoot = createRoot(mapEl);
  mapRoot.render(
    <Mappage regionsData={searchRegions} />
  );
}

const wishlistEl = document.getElementById('favorites');
if (wishlistEl) {
  const wishlistElRoot = createRoot(wishlistEl);
  wishlistElRoot.render(
    <>
   
    <Favorites regionsData={searchRegions}/>
    </>
  );
}

const headerSearchEl = document.getElementById('header-search-root');
if (headerSearchEl && !document.getElementById('search-root') && !document.getElementById('favorites') && !document.getElementById('map-root')) {
  const dummyEl = document.createElement('div');
  dummyEl.id = 'public-safety-search-mount';
  dummyEl.style.display = 'none';
  document.body.appendChild(dummyEl);

  const publicSafetyRoot = createRoot(dummyEl);
  publicSafetyRoot.render(
    <Favorites regionsData={searchRegions} />
  );
}

function initChartComponent() {
  // Check if chart container exists on the page
  const chartContainer = document.getElementById('chart-container');
  if (chartContainer) {
    // Initialize the chart component
    const chartInstance = new ChartComponent();
    
    // Store reference globally for cleanup if needed
    window.chartComponentInstance = chartInstance;
  }
}


export { initMobileMenu, initScrollEffects };
